import React, { FC } from 'react'
import { createUseStyles } from 'react-jss'
import Checkbox from '../../ui/FormElememts/Checkbox'

export interface IItem {
    name: string
}

type Props = {
    items: IItem[]
    isSelected: (item: IItem) => boolean
    handleChange: (item: IItem) => void
}

const useStyles = createUseStyles({
    formControl: {
        padding: '20px 0',
    },
})

const Checkboxes: FC<Props> = ({ items, handleChange, isSelected }) => {
    const classes = useStyles()

    return (
        <>
            {items.map((item: IItem) => {
                return (
                    <div key={item.name} className={classes.formControl}>
                        <Checkbox
                            onChange={() => {
                                handleChange(item)
                            }}
                            label={item.name}
                            isChecked={isSelected(item)}
                        />
                    </div>
                )
            })}
        </>
    )
}

export { Checkboxes }
